<div class="flex-shrink-0 p-3" style="width: 280px; height:100%;">
  <a routerLink="/settings/mmssetting"
    class="d-flex align-items-center mb-3 link-body-emphasis text-decoration-none justify-content-center">
    <img class="bi pe-none me-2" width="60%" height="45" src="assets/img/logo.png" />
  </a>
  <div class="side-bar-container">
    <ul class="list-unstyled ps-0 sidebar">
      <li *ngFor="let config of getActiveConfigurations()" 
          [class.active]="router.url === config.routerURL">
        <a *ngIf="hasPermission(config.id)"
           [routerLink]="config.routerURL"
           class="link-body-emphasis d-inline-flex text-decoration-none rounded w-95">
          {{ config.name }}
        </a>
        <span *ngIf="!hasPermission(config.id)"
              class="disabled-config d-inline-flex text-decoration-none rounded w-95"
              title="This option is disabled due to lack of permissions">
          {{ config.name }}
        </span>
      </li>
    </ul>
  </div>
</div>